import React from 'react';
import './tableSelector.css';

const TableSelector = ({ tables, setActiveTable }) => {
  return (
    <div className="table-selector">
      <ul>
        {tables.map((table, index) => (
          <li key={index} onClick={() => setActiveTable(table)}>
            {table}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TableSelector;